module.exports = __webpack_public_path__ + "img/tab-1.8e903123.png";